import { classes, st } from './DraggableContainer.st.css';
import { useContext } from 'react';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';

export interface UseDraggableContainerProps {
  draggable?: boolean;
  dragging?: boolean;
  dragDisabled?: boolean;
  dim?: boolean;
  highlight?: boolean;
}

export function useDraggableContainer(props: UseDraggableContainerProps) {
  const { draggable, dragging, dragDisabled, dim, highlight } = props;
  const { newColorsBranding } = useContext(WixStyleReactContext);

  return {
    className: st(classes.root, {
      newColorsBranding,
      draggable,
      dragging,
      dragDisabled,
      dim,
      highlight,
    }),
  };
}
